import { AVAILABLE_SERVICE } from '@abiglobalhealth/go-types'
import { useMemo } from 'react'

import { useConsultationType } from '@/hooks/useConsultationType'

export const useIsConsultationType = (consultationType: AVAILABLE_SERVICE) => {
  const { consultationType: currentConsultationType } = useConsultationType()

  return useMemo(() => consultationType === currentConsultationType, [consultationType, currentConsultationType])
}
